'use client'

import styles from './NewsList.module.scss'
import { useInView } from 'react-intersection-observer'
import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { useGetAllNewsMutation } from '@/shared/api-rtk/index.js'
import { TOAST_ERROR } from '@/shared/constants/toastTypes.js'
import { useCutLengthText } from '@/shared/hooks/useCutLengthText.js'
import { Card, Placeholder } from 'react-bootstrap'
import { IMAGE_DIR } from '@/shared/constants/linksApi'
import { redirect } from 'next/navigation'

export function NewsList({ onMount }) {
    const { ref, inView } = useInView({
        threshold: 0,
        triggerOnce: true,
    })

    const navigate = (url) => redirect(url)

    const [news, setNews] = useState([])
    const [getNews, { isLoading }] = useGetAllNewsMutation()

    useEffect(() => {
        getNews()
            .unwrap()
            .then((res) => {
                if (res.result === 'success') {
                    setNews(Object.values(res.data).reverse())
                }
            })
            .finally(() => {
                onMount()
            })
    }, [])

    const imageOnError = (event) => {
        event.currentTarget.src = '/bg/stub-pictures-news.png'
    }

    return (
        <div
            ref={ref}
            className={classNames(
                styles.wrapper,
                inView && 'animate__animated animate__fadeIn'
            )}
        >
            <div style={{cursor: 'pointer'}} onClick={() => navigate("/news")} className={styles.title}>Новости</div>
            <div className={styles.itemsContainer}>
                {isLoading &&
                    Array.apply(null, Array(10)).map((_, i) => (
                        <div
                            key={`${i}-new-placeholder`}
                            className={styles.item}
                        >
                            <div className={styles.itemTitle}>
                                <Placeholder
                                    xs={12}
                                    as={Card.Title}
                                    animation="glow"
                                />
                            </div>
                            <div className={styles.itemText}>
                                <Placeholder as={Card.Text} animation="glow">
                                    <Placeholder xs={7} />{' '}
                                    <Placeholder xs={4} />{' '}
                                    <Placeholder xs={4} />{' '}
                                    <Placeholder xs={6} />{' '}
                                    <Placeholder xs={8} />
                                    <Placeholder xs={7} />{' '}
                                    <Placeholder xs={4} />{' '}
                                    <Placeholder xs={4} />{' '}
                                </Placeholder>
                            </div>
                        </div>
                    ))}

                {!isLoading &&
                    news.map((item) => {
                        const cuteText = useCutLengthText(item.description, 125)
                        const cuteTitle = item.title.replaceAll('&quot;', '')

                        {
                            /* console.log(item.image); */
                        }
                        return (
                            <a
                                href={`/${item.url}`}
                                target="_blank"
                                key={item.news_id}
                                className={styles.item}
                            >
                                <img
                                    className={styles.itemImage}
                                    src={`${IMAGE_DIR}${item.image}`}
                                    alt={'item'}
                                    onError={imageOnError}
                                />
                                <div className={styles.itemTitle}>
                                    {cuteTitle}
                                </div>
                                <div className={styles.itemText}>
                                    {cuteText}
                                </div>
                            </a>
                        )
                    })}
            </div>
        </div>
    )
}
